export default __webpack_public_path__ + "static/media/accounting.735cf9e3.png";